import { KeyTextOverlayConfig, VideoTemplateEditorFeatures } from './types';

export const DEFAULT_FEATURES: VideoTemplateEditorFeatures = {
  templates: true,
  waveform: true,
  captions: 'hidden',
};

export const KEY_TEXT_OVERLAY_SLOTS: ReadonlyArray<keyof KeyTextOverlayConfig> = [
  'episodeTitle',
  'podcastTitle',
];

export const OPTION_TILE_FEATURE_PATHS = {
  effects: ['effects'],
  waveform: ['waveform'],
  image: ['image'],
  introOutro: ['introOutro'],
  watermark: ['watermark'],
  text: ['text'],
  progress: ['progress'],
  background: ['background'],
  templates: ['templates'],
  captions: ['captions'],
};
